import { forwardRef } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { html } from './chartsHtml';
import { WebView } from '../WebView';

export const HighChartsRenderer = forwardRef(function HighChartsRenderer(
  { onRendererLoaded },
  ref,
) {
  const isMobile = Platform.OS !== 'web';

  return isMobile ? (
    <WebView ref={ref} source={{ html }} onLoadEnd={onRendererLoaded} />
  ) : (
    <View style={styles.container}>
      <iframe
        ref={ref}
        title="web-stars-page"
        srcDoc={html}
        height="100%"
        width="100%"
        frameBorder={0}
        allowFullScreen
        onLoad={onRendererLoaded}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
